<template>
  <div v-loading="dataLoading" class="transaction-detail-wrapper">
    <template v-if="detailsData">
      <div class="detail-top">
        <div class="title-txt margin-bottom-16">{{ $t('message.tableCommon.refundAmount') }}</div>
        <div class="amount-box">
          <span class="amount-txt">{{ detailsData.txnAmount ? detailsData.txnAmount.amount : '' }}</span>
          <span class="currency-txt">{{ detailsData.txnAmount ? detailsData.txnAmount.currency : '' }}</span>
        </div>
        <div class="txn-info">
          <div class="txn-item-box margin-right-32">
            <p class="label">{{ $t('message.tableCommon.status') }}</p>
            <p class="value">
              <span :class="['status', `status-${detailsData.onlineRefundStatus}`]">{{ setTxnStatus(detailsData)
                }}</span>
            </p>
          </div>
          <div class="txn-item-box margin-right-32">
            <p class="label">{{ $t('message.tableCommon.refundSerialNumber') }}</p>
            <p class="value">
              <TextView :text="detailsData.txnId" type="copy"></TextView>
            </p>
          </div>
          <div class="txn-item-box no-border">
            <p class="label">{{ $t('message.transaction.refundProcessTime') }}</p>
            <p class="value">{{ detailsData.txnTime }}</p>
          </div>
          <div class="txn-item-box">
          </div>
        </div>
      </div>
      <!-- 退款信息 -->
      <div class="margin-top-32">
        <RhcnDescriptions :details-condition="refundCondition"></RhcnDescriptions>
      </div>
      <!-- 退款凭证 -->
      <div class="margin-top-32">
        <RhcnDescriptions :details-condition="receiptCondition"></RhcnDescriptions>
      </div>
    </template>
  </div>
</template>
<script>

import RhcnDescriptions from '@/components/form/descriptions.vue';
import TextView from '@/components/form/text-view.vue';
import { ShowWarningMessage } from '@/components/modal/tips/message-tips';
import { REQUIRED } from '@/components/validation/tool/validator';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData, splicingAmountAndCurrency } from '@/utils/tools/constant';
import { isNullForDisplay, formatCardNumber } from '@/utils/tools/utils';
import { checkPermission } from '@/views/index/api/index';
import TransitionService from '@/views/transaction/api/transaction-query.service';
import { OnlineRefundStatus, RefundStatus } from '@/views/transaction/status/transaction';

export default {
  components: {
    RhcnDescriptions,
    TextView,
  },
  data() {
    return {
      dataLoading: false,
      getTransactionDetails: TransitionService.getTransactionDetails,
      transactionId: '',
      txnTypeList: [],
      txnStatusList: [],
      refundStatusList: [],
      chargebackStatusList: [],
      receiptCondition: {},
      refundCondition: {},
      getEnantiomericValue,
      detailsData: null,
      showRefund: false,
      isQueryHistory: false,
      statusList: [],
    };
  },
  methods: {
    getRefundTemplate(allData) {
      return {
        topTitle: 'message.transaction.refundInfo',
        listTemplate: [
          {
            titleBar: { title: 'message.transaction.refundArn' },
            key: 'arn',
            type: 'text-view',
            textViewType: 'copy',
            showLabelTips: true,
            text: this.$t('message.transaction.refundArnTips'),
          },
          {
            titleBar: { title: 'message.transaction.paymentSuccessTime' },
            key: 'originTxnTime',
          },
          {
            titleBar: { title: 'message.transaction.originTxnId' },
            key: 'originTxnId',
            type: 'text-view',
            textViewType: 'link',
            onLink: () => {
              const params = {
                id: allData.originTxnId,
              };
              if (this.isQueryHistory) {
                params.isHistory = '1';
              }
              this.$router.push({
                path: '/transaction/details',
                query: params,
              });
            },
          },
          {
            titleBar: { title: 'message.tableCommon.refundTime' },
            key: 'refundApplyTime',
          },
          {
            titleBar: { title: 'message.tableCommon.txnType' },
            key: 'txnType',
            textFunc: (data) => getEnantiomericValue(this.txnTypeList, data.txnType),
          },
          {
            titleBar: { title: 'message.tableCommon.refundAuditTime' },
            key: 'auditTime',
          },
          {
            titleBar: { title: 'message.tableCommon.refundType' },
            key: 'refundStatus',
            textFunc: (data) => data.refundStatus ? this.$t(getEnantiomericValue(RefundStatus, data.refundStatus)) : '--',
          },
          {
            titleBar: { title: 'message.transaction.refundProcessTime' },
            key: 'txnTime',
          },
          {
            titleBar: { title: 'message.settlement.refundAmount' },
            key: 'txnAmount',
            textFunc: (data) => splicingAmountAndCurrency(data.txnAmount && data.txnAmount.currency, data.txnAmount && data.txnAmount.amount),
          },
          {
            titleBar: { title: 'message.transaction.refundRespCode' },
            key: 'errorCode',
            type: 'text-view',
            textViewType: 'blank_link',
            textViewDesc: this.$t('message.transaction.respCodeList'),
            onLink: () => {
              window.open('https://docs.onerway.com/failure', '_blank');
            },
          },
          {
            titleBar: { title: 'message.tableCommon.originTxnAmount' },
            key: 'originTxnAmount',
            textFunc: (data) => splicingAmountAndCurrency(data.originTxnAmount && data.originTxnAmount.currency, data.originTxnAmount && data.originTxnAmount.amount),
          },
          {
            titleBar: { title: 'message.transaction.refundRespMsg' },
            key: 'errorMsg',
            type: 'text-view',
            textFunc: (data) => data.errorMsg === 'success' ? 'Success' : data.errorMsg,
            textViewType: 'emphasize',
          },
          {
            titleBar: { title: '' },
            key: 'placeholder',
            type: 'placeholder',
          },
          {
            titleBar: { title: 'message.transaction.advise' },
            key: 'adviceMsg',
          },
        ],
        data: allData,
      };
    },
    getRefundReceiptTemplate(allData) {
      return {
        topTitle: 'message.transaction.refundReceipt',
        listTemplate: [
          {
            titleBar: { title: 'message.settlement.refundAmount' },
            key: 'txnAmount',
            textFunc: (data) => splicingAmountAndCurrency(data.txnAmount && data.txnAmount.currency, data.txnAmount && data.txnAmount.amount),
          },
          {
            titleBar: { title: 'message.subscription.cardNo' },
            key: 'cardNumber',
          },
          {
            titleBar: { title: 'message.transaction.refundStatus' },
            key: 'refundStatus',
            textFunc: (data) => data.onlineRefundStatus ? this.$t(getEnantiomericValue(OnlineRefundStatus, data.onlineRefundStatus)) : '--',
          },
          {
            titleBar: { title: 'message.tableCommon.paymentType' },
            key: 'cardBin',
          },
          {
            titleBar: { title: 'message.transaction.refundProcessTime' },
            key: 'txnTime',
          },
          {
            titleBar: { title: 'message.transaction.refundArn' },
            key: 'arn',
          },
          {
            titleBar: { title: 'message.tableCommon.merchantOrderNumber' },
            key: 'merchantTxnId',
          },
          {
            titleBar: { title: '' },
            key: 'placeholder',
            type: 'placeholder',
          },
          {
            titleBar: { title: 'message.tableCommon.website' },
            key: 'website',
          },
        ],
        data: allData,
      };
    },
    async fetchTransactionDetail() {
      await this.getTransactionDetails(this.transactionId, { isHistory: this.$route.query.isHistory || '0' }).then((data) => {
        this.detailsData = data;
        this.receiptCondition = this.getRefundReceiptTemplate(data);
        if (this.receiptCondition?.data?.cardNumber) {
          this.receiptCondition.data.cardNumber = formatCardNumber(this.receiptCondition.data.cardNumber);
        }
        this.refundCondition = this.getRefundTemplate(data);
      });
    },
    async initDetailsAll() {
      this.receiptCondition = this.getRefundReceiptTemplate({});
      if (this.receiptCondition?.data?.cardNumber) {
        this.receiptCondition.data.cardNumber = formatCardNumber(this.receiptCondition.data.cardNumber);
      }
      this.dataLoading = true;
      try {
        await this.fetchTransactionDetail();
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    // 交易状态固定显示
    setTxnStatus(data) {
      return this.$t(getEnantiomericValue(OnlineRefundStatus, data.onlineRefundStatus));
    },
    amountJudgment(params) {
      if (!this.detailsData || !this.detailsData.refundAmount || +this.detailsData.refundAmount.amount - +params.amount < 0) {
        ShowWarningMessage(this.$t('message.transaction.maximumRefundAmount') + this.detailsData.refundAmount.amount);
        return false;
      }
      return true;
    },
    getAmountDisplay(data) {
      if (data) {
        return splicingAmountAndCurrency(data.currency, data.amount);
      }
      return '';
    },
    async initMethod() {
      this.transactionId = this.$route.query.id;
      checkPermission('transaction:list:refund').then((res) => {
        this.showRefund = res;
      });
      await GlobalData.getDictList(['TXN_TYPE', 'MERC_TXN_STATUS', 'MERC_REFUND_STATUS', 'MERC_CHARGEBACK_STATUS']).then((res) => {
        this.txnTypeList = initSelectedData(res.TXN_TYPE);
        this.txnStatusList = initSelectedData(res.MERC_TXN_STATUS);
        this.refundStatusList = initSelectedData(res.MERC_REFUND_STATUS);
        this.chargebackStatusList = initSelectedData(res.MERC_CHARGEBACK_STATUS);
      }).catch(() => {
      });
      this.initDetailsAll();
      this.isQueryHistory = this.$route.query.isHistory === '1';
    },
  },
  mounted() {
    this.initMethod();
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.transaction-detail-wrapper {
  padding-bottom: 50px;

  :deep(.rhcn-descriptions) {
    .el-descriptions-item__label {
      width: 120px;
      min-width: 120px;
    }
  }
}

html[lang=en] .transaction-detail-wrapper {
  :deep(.rhcn-descriptions) {
    .el-descriptions-item__label {
      width: 160px;
      min-width: 160px;
    }
  }
}

.detail-top {
  margin-bottom: 30px;
  border-radius: 8px;
  border: 1px solid #EFEFF4;
  padding: 24px;

  .title-txt {
    font-size: 14px;
    font-family: Avenir-Book, Avenir;
    font-weight: normal;
    color: $color-description-new;
    line-height: 19px;
    border-bottom: 1px solid #EFEFF4;
    padding-bottom: 16px;
  }

  .amount-box {
    display: flex;
    align-items: center;
    margin-top: 7px;
    margin-bottom: 15px;
    color: $color-text-primary-new;
    font-weight: 800;

    .amount-txt {
      font-size: 32px;
      line-height: 30px;
      margin-right: 10px;
    }

    .currency-txt {
      color: #667085;
      font-size: 32px;
      font-weight: 400;
    }

    .currency-icon {
      width: 26px;
      margin-right: 38px;
    }

    .status {
      font-size: 14px;
      line-height: 30px;
      padding: 0 8px;
      height: 30px;
      border-radius: 4px;
      background: rgba(252, 100, 45, 0.15);

      &-S {
        background: rgba(0, 221, 40, 0.15);
      }

      &-P,
      &-U {
        background: rgba(255, 178, 9, 0.15);
      }

      &-N {
        background: #F1F5F7;
      }
    }
  }

  .txn-info {
    display: flex;

    .txn-item-box {
      flex: 1;
      border-right: 1px solid #EFEFF4;

      &.no-border {
        border-right: none;
      }

      &:last-child {
        border-right: none;
      }

      .label {
        font-weight: 400;
        font-size: 14px;
        color: #667085;
        line-height: 18px;
        margin-bottom: 8px;
      }

      .value {
        font-weight: 400;
        font-size: 14px;
        color: $color-text-primary-new;
        line-height: 18px;
      }
    }

    .status {
      font-weight: bold;
      font-size: 12px;
      line-height: 30px;
      padding: 2px 8px;
      height: 20px;
      border-radius: 20px;
      background: #FFFAEB;
      color: #CC8406;

      &-S,
      &-ACCEPT,
      &-SAS,
      &-FAS,
      &-pass {
        background: #ECFDF3;
        color: #027A48;
      }

      &-F,
      &-SAT,
      &-SAF,
      &-FAT,
      &-FAF,
      &-fail {
        background: #FEF3F2;
        color: #912018;
      }

      &-N,
      &-REVOKE {
        background: #EBEEF1;
        color: #667085;
      }
    }
  }
}

.timeline-box {
  .timeline-item {
    position: relative;
    display: flex;
    align-items: flex-start;
    min-height: 56px;
    padding-bottom: 16px;

    .timeline-item-icon {
      position: relative;
      width: 9px;
      height: 9px;
      border: 1px solid #D9D9D9;
      border-radius: 50%;
      z-index: 1;
    }

    .timeline-item-content {
      .timeline-item-title {
        font-weight: bold;
        font-size: 16px;
        color: $color-black;
        line-height: 16px;
      }

      .timeline-item-time {
        font-weight: 400;
        font-size: 12px;
        color: #9EA9C1;
        line-height: 20px;
      }

      .timeline-item-link {
        //
      }
    }

    .time-line {
      position: absolute;
      left: 5px;
      top: 13px;
      height: 62px;
      border-left: 1px solid #EFEFF4;
      z-index: 0;
    }

    &:last-child {
      padding-bottom: 0;

      .time-line {
        height: 10px;
      }
    }
  }
}
</style>
